import { create } from "zustand"
import { IPWhitelistEntry, IPBannedEntry, IPStoreProps } from "./data"
import {
    retrieveWhitelist as fetchWhitelist,
    retrieveBannedList as fetchBannedList,
    addToWhitelist as apiAddToWhitelist,
    removeFromWhitelist as apiRemoveFromWhitelist,
    unbanIP as apiUnbanIP,
    banIP as apiBanIP
} from "./actions"

export const useIPStore = create<IPStoreProps>((set, get) => ({
    loading: false,
    whitelistLoading: false,
    bannedLoading: false,
    whitelist: null,
    bannedList: null,

    async retrieveWhitelist() {
        if (get().whitelistLoading) return ""
        set(state => ({ whitelistLoading: true }))
        try {
            const res = await fetchWhitelist()
            const whitelist = res.Msg?.whitelist as IPWhitelistEntry[] || []
            set(state => ({ whitelist: whitelist, whitelistLoading: false }))
            return "200"
        } catch (err) {
            set(state => ({ whitelistLoading: false }))
            return "error"
        }
    },

    async retrieveBannedList() {
        if (get().bannedLoading) return ""
        set(state => ({ bannedLoading: true }))
        try {
            const res = await fetchBannedList()
            const bannedList = res.Msg?.banned as IPBannedEntry[] || []
            set(state => ({ bannedList: bannedList, bannedLoading: false }))
            return "200"
        } catch (err) {
            set(state => ({ bannedLoading: false }))
            return "error"
        }
    },

    async addToWhitelist(ip, description) {
        const code = await apiAddToWhitelist(ip, description)
        if (code === "200") {
            const whitelist = [...(get().whitelist || [])]
            const newEntry: IPWhitelistEntry = {
                ip: ip,
                addedAt: new Date().toISOString(),
                addedBy: "current_user",
                description: description
            }
            whitelist.unshift(newEntry)
            set(state => ({ whitelist: whitelist }))
        }
        return code
    },

    async removeFromWhitelist(ip) {
        const code = await apiRemoveFromWhitelist(ip)
        if (code === "200") {
            const whitelist = [...(get().whitelist || [])]
            const index = whitelist.findIndex(item => item.ip === ip)
            if (index >= 0) {
                whitelist.splice(index, 1)
                set(state => ({ whitelist: whitelist }))
            }
        }
        return code
    },

    async unbanIP(ip) {
        const code = await apiUnbanIP(ip)
        if (code === "200") {
            const bannedList = [...(get().bannedList || [])]
            const index = bannedList.findIndex(item => item.ip === ip)
            if (index >= 0) {
                bannedList.splice(index, 1)
                set(state => ({ bannedList: bannedList }))
            }
        }
        return code
    },

    async banIP(ip, reason, durationHours, description) {
        const code = await apiBanIP(ip, reason, durationHours, description)
        if (code === "200") {
            // refresh the whole list to get all metadata from server
            get().retrieveBannedList()
        }
        return code
    }
}))